import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IndicationsService } from 'src/app/services/indications.service';
import { LoginService } from 'src/app/services/login.service';

@Injectable({
  providedIn: 'root',
})
export class AllowIndicationGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly service = inject(IndicationsService);
  private readonly loginService = inject(LoginService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const id = route.paramMap.get('id');

    if (id !== 'novo') {
      return of(true);
    }

    return this.service.countIndicationV2().pipe(
      map((data: boolean) => {
        if (data) {
          return true;
        }

        this.loginService.showMessage('Seu plano atingiu o limite máximo de agendamentos.');

        return this.router.createUrlTree(['/signature']);
      }),
      catchError((err) => {
        const message = err?.error?.message || err?.message || '';
        this.loginService.showMessage(message);

        return throwError(() => err);
      })
    );
  }
}
